import { Component, OnInit, OnDestroy, ApplicationRef, effect } from '@angular/core';
import packageJson from '../../package.json';

import { MenuController, AlertController } from '@ionic/angular';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { UserService } from './services/dal/user.service';
import { SubscriptionService } from './services/dal/subscription.service';
import { SwUpdate } from '@angular/service-worker';
import { first } from 'rxjs/operators';
import { interval, concat, Subscription, Observable } from 'rxjs';
import { SubscriptionHandler } from './services/subscriptionHandler.service';
import { Store, Action } from '@ngrx/store';
import * as fromUser from './state/user';
import * as fromBar from './state/bar/reducer';
import * as UserActions from './state/user/actions';
import * as fromSubscription from './state/subscription';

import { DalHelper } from './services/dal.helper';
import { FcmService } from './services/fcm.service';
import { RatingService } from './services/rating.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { IAppPage } from './models/appPage';
import { Capacitor } from '@capacitor/core';
import * as fromKeg from './state/keg/reducer';
import { StatusBar } from '@capacitor/status-bar';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { LOG_LEVEL, Purchases } from '@revenuecat/purchases-capacitor';
import { environment } from 'environments/environment';
import * as fromRevenuecatCustomer from 'app/state/revenuecat-customer';
import * as fromRevenueCat from 'app/state/revenuecat';
import * as fromNotification from 'app/state/notification';
import * as fromSupport from 'app/state/support';
import { appPages } from './menu-items.static';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    './app.component.scss',
    './side-menu/styles/side-menu.scss',
    './side-menu/styles/side-menu.shell.scss',
    './side-menu/styles/side-menu.responsive.scss',
  ],

})
export class AppComponent implements OnInit, OnDestroy {



  public selectedIndex = 0;
  public notifications: any = 0;
  public appPages: IAppPage[] = [
    {
      id: 0,
      profileItem: false,
      isPremium: false,
      title: 'Home',
      url: '/home',
      icon: 'home',
    },
    {
      id: 1,
      profileItem: false,
      isPremium: false,
      title: 'Inventory',
      url: '/inventory',
      icon: 'beer',
    },
    {
      id: 2,
      profileItem: false,
      isPremium: false,
      title: 'Taps & Towers',
      url: '/inventory/taps',
      src: 'assets/icons/outline/tap.svg'
    },
    {
      id: 3,
      profileItem: false,
      isPremium: false,
      title: 'Kegs',
      url: '/inventory/kegs',
      src: 'assets/icons/outline/keg.svg'
    },
    {
      id: 4,
      title: 'OnTap TV',
      url: '/tv',
      icon: 'tv',
      isPremium: true,
      profileItem: false,
    },
    {
      id: 5,
      title: 'Settings',
      url: '/settings',
      icon: 'settings',
      isPremium: false,
      profileItem: false,
    },
    // {
    //   id: 6,
    //   title: 'Subscription',
    //   url: '/subscription',
    //   icon: 'star',
    //   isPremium: false,
    //   profileItem: true
    // },
    {
      id: 7,
      title: 'Notifications',
      badge: 0,
      url: '/notifications',
      icon: 'notifications',
      isPremium: false,
      profileItem: false
    },
  ];

  hasPremium = this.store.selectSignal(fromSubscription.getHasPremium);
  user = this.store.selectSignal(fromUser.selectUser);
  bar = this.store.selectSignal(fromBar.selectBar);
  notificationCount = this.store.selectSignal(fromNotification.selectUnreadCount);
  supportUnreadCount = this.store.selectSignal(fromSupport.selectUnreadByUserCount);
  kegs = this.store.selectSignal(fromKeg.selectAllItems);
  private ratingPromptScheduled = false;

  barId$!: Observable<string>;
  textDir = 'ltr';
  private initialDataLoaded = false;
  private subs: Subscription[] = [];
  // The RevenueCat customer-info listener is registered ONLY once (user$ can
  // emit multiple times); otherwise we'd get duplicate dispatches.
  private rcListenerRegistered = false;

  public version: string = packageJson.version;

  constructor(
    private appRef: ApplicationRef,
    private swUpdate: SwUpdate,
    private router: Router,
    public authService: AuthService,
    private userService: UserService,
    private menuController: MenuController,
    private alertController: AlertController,
    private subscriptionService: SubscriptionService,
    private sh: SubscriptionHandler,
    private store: Store,
    private dalHelper: DalHelper,
    private fcmService: FcmService,
    private ratingService: RatingService,
  ) {
    this.initializeApp();

    effect(() => {
      const bar = this.bar();
      this.setDarkMode(bar?.darkMode ?? false);
    });


    effect(() => {
      const count = this.notificationCount();
      const notificationsPage = this.appPages.find(p => p.id === 7);
      if (notificationsPage) {
        notificationsPage.badge = count > 0 ? count : 0;
      }
    });

    effect(() => {
      const count = this.supportUnreadCount();
      const settingsPage = this.appPages.find(p => p.id === 5);
      if (settingsPage) {
        settingsPage.badge = count > 0 ? count : 0;
      }
    });

    // Register for push notifications as soon as the active bar and user
    // are loaded — independent of which page the user lands on.
    effect(() => {
      const bar = this.bar();
      const user = this.user();
      if (bar && user?.uid) {
        this.fcmService.initPush(bar, user.uid);
      }
    });

    // Maybe ask for a native app rating once the user is loaded and has
    // some keg activity. RatingService applies all gating internally and
    // is safe to call repeatedly.
    effect(() => {
      const user = this.user();
      const kegs = this.kegs();
      if (this.ratingPromptScheduled) return;
      if (!user?.uid || !kegs) return;
      this.ratingPromptScheduled = true;
      const uid = user.uid;
      const kegCount = kegs.length;
      setTimeout(() => {
        this.ratingService.checkAndMaybePrompt(uid, kegCount);
      }, 5000);
    });


  }


  async initializeApp() {

    console.debug('Inne i ios 1');

    // Unregister any previously cached service workers on native platforms
    if (Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(r => r.unregister());
      });
    }

    this.barId$ = this.store.select(fromUser.selectBarId);

    if (this.swUpdate.isEnabled) {
      const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
      // const everySixHours$ = interval(15 * 1000); // 15 seconds
      const everySixHours$ = interval(6 * 60 * 60 * 1000);
      const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);
      const six$ = everySixHoursOnceAppIsStable$.subscribe(() => {
        this.swUpdate.checkForUpdate();
      });
      this.subs.push(six$);
      this.sh.addSubscription(six$);
    }

  }


  handleRefresh(event: any) {
    this.store.dispatch(UserActions.loadUser());
    this.store.dispatch(UserActions.loadBarId());

    const barIdSub$ = this.barId$.subscribe(async (barId) => {
      if (barId) {
        this.dalHelper.dispatchAllDals(barId, true);
        event.target.complete();
      }
    });
    this.subs.push(barIdSub$);
    this.sh.addSubscription(barIdSub$);
  }


  async ngOnInit() {
    // Initialize Google and Facebook Sign In for native platforms (iOS/Android)
    try {
      const platform = Capacitor.getPlatform();
      const isNativeApp = Capacitor.isNativePlatform();

      if (isNativeApp) {
        // Initialize Google and Facebook first
        await SocialLogin.initialize({
          google: {
            iOSClientId: environment.signon.google.iosClientId,
            webClientId: environment.signon.google.androidClientId,
          },
          facebook: {
            appId: environment.signon.facebook.appId,
            clientToken: environment.signon.facebook.clientToken
          },
        });

        // Initialize Apple separately for Android (web-based OAuth)
        // Must be separate because the plugin's Java code aborts the entire
        // initialize() call if Apple init fails, which would break Google/Facebook
        if (platform === 'android') {
          try {
            await SocialLogin.initialize({
              apple: {
                clientId: environment.signon.apple.serviceId,
                redirectUrl: environment.signon.apple.redirectUrl,
              },
            });
          } catch (appleError) {
            console.error('Failed to initialize Apple login on Android:', appleError);
          }
        }
      } else {
        console.info('Web platform - skipping native social login initialization');
      }
    } catch (error) {
      console.error('Failed to initialize social login:', error);
      console.error('Error details:', JSON.stringify(error));
    }

    if (Capacitor.getPlatform() === 'android') {
      try {
        await StatusBar.setOverlaysWebView({ overlay: false });
        await StatusBar.show();
      } catch (err) {
        console.error('Error configuring StatusBar:', err);
      }
    }

    // Handle App Links (Android) and Universal Links (iOS).
    // iOS: SFSafariViewController triggers Universal Links → app opens with https URL.
    // Android: CCT does not trigger App Links; instead the web app at barhelper.app
    // detects ?code= and redirects to barhelper://settings/untappd?code=... which
    // opens the native app via the custom scheme intent filter in AndroidManifest.
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const url = new URL(event.url);
      // https://barhelper.app/settings/untappd?code=... (iOS Universal Link)
      const isHttpsUntappd = url.protocol === 'https:' && url.pathname.startsWith('/settings/untappd');
      // barhelper://settings/untappd?code=... (Android custom scheme from web redirect)
      const isCustomSchemeUntappd = url.protocol === 'barhelper:' && url.host === 'settings' && url.pathname.startsWith('/untappd');
      if (isHttpsUntappd || isCustomSchemeUntappd) {
        const code = url.searchParams.get('code');
        if (code) {
          this.router.navigate(['/settings/untappd'], { queryParams: { code } });
        }
      }
    });

    this.store.dispatch(UserActions.loadUser());
    this.store.dispatch(UserActions.loadBarId());


    const barIdSub$ = this.barId$.subscribe(async (barId) => {
      if (barId && !this.initialDataLoaded) {
        this.initialDataLoaded = true;
        this.dalHelper.dispatchAllDals(barId);
        SplashScreen.hide();
      }
    });
    this.subs.push(barIdSub$);
    this.sh.addSubscription(barIdSub$);

    if (this.swUpdate.isEnabled) {
      const swUpdate$ = this.swUpdate.versionUpdates.subscribe(async (event) => {
        await this.confirmReloadNewVersion(event);
      });
      this.subs.push(swUpdate$);
      this.sh.addSubscription(swUpdate$);
    }

    const userSub$ = this.authService.user$.subscribe(async (user) => {
      if (user != null) {
        if (Capacitor.isNativePlatform()) {
          try {
            const apiKey = Capacitor.getPlatform() === 'ios'
              ? environment.revenueCat.appleApiKey
              : environment.revenueCat.googleApiKey;
            await Purchases.configure({ apiKey });
            await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
            if (user.uid) {
              // RC IDENTITY (≠ Firebase login): links the RevenueCat customer to
              // the Firebase uid so purchases attach to the correct user. Set
              // here BEFORE any purchase can happen. This is NOT a status refresh.
              const cust = await Purchases.logIn({ appUserID: user.uid });
              this.store.dispatch(fromRevenueCat.updateLoginItem({ loginItem: cust }));
              if (cust.customerInfo != null) {
                this.store.dispatch(fromRevenueCat.updateCustomerInfo({ customerInfo: cust.customerInfo }));
              }
            }

            // Live status update during the session: RevenueCat does NOT push
            // from the backend — the listener fires on launch, getCustomerInfo
            // and purchase/restore. This catches renewal/refund/delayed
            // purchase without an app restart. Registered only once.
            if (!this.rcListenerRegistered) {
              this.rcListenerRegistered = true;
              Purchases.addCustomerInfoUpdateListener((info) => {
                this.store.dispatch(fromRevenueCat.updateCustomerInfo({ customerInfo: info }));
              });
            }
          } catch (err) {
            console.error('Error setting up RevenueCat:', err);
          }
        }

        this.userService.getMetadataUser(user.uid).subscribe(async () => {
          try {
            const barId = await this.authService.selectUserBarId();
            this.checkSubscriptionTimer(barId);
          } catch {
            // Token claim is still missing barId (new/unverified user) — not an
            // actionable error. Swallow it so it doesn't become an unhandled
            // rejection in Sentry (BAR-HELPER-25X).
          }
          if (!user.emailVerified) {
            this.router.navigate(['verify-email']);
          }
        });
      }
    });
    this.subs.push(userSub$);
    this.sh.addSubscription(userSub$);

    const path = window.location.pathname.split('/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(
        (page) => page.title.toLowerCase() === path.toLowerCase()
      );
    }
  }


  ngOnDestroy() {
    this.subs.forEach(sub => sub?.unsubscribe());
  }



  async signOut() {
    this.menuController.close();
    this.menuController.enable(false);
    await this.authService.logout().then(() => {
      this.router.navigate(['login']);
    });
  }

  private setDarkMode(darkMode: boolean) {
    document.body.classList.toggle('dark', darkMode ?? false);
  }

  private checkSubscriptionTimer(barId: string) {
    setInterval(() => this.subscriptionService.userHasPremium(barId, true), 43200000);
  }


  async confirmReloadNewVersion(event: any) {
    if (event.type !== 'VERSION_READY') {
      return;
    }

    const alert = await this.alertController.create({
      header: 'Update available!',
      subHeader: `New version: ${event.latestVersion.appData.version}`,
      message: 'Do you want to load the new version?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes please',
          handler: () => window.location.reload()
        }
      ]
    });

    await alert.present();
  }


  gotTo(hasPremium: boolean, page: any, i: number): void {
    this.selectedIndex = i;
    const route = (hasPremium || !page.isPremium) ? page.url : 'subscription';
    this.router.navigate([route]);
  }
}
